import { useCanAccessMenu } from "@/hooks/use-menu-permissions";
import { useFeatureFlag } from "@/hooks/use-feature-flag";
import { usePermissions } from "@/hooks/use-permissions";

/**
 * Kan den aktive brukeren booke kundemøter? Samme regel som edge function
 * calendar-book-meeting: leads-flagget er på, og brukeren er admin eller har
 * menynøkkelen salgsmuligheter. Brukes til å skjule «Book møte» utenfor salgsflaten.
 */
export function useCanBookMeetings(): boolean {
  const enabled = useFeatureFlag("feature_crm_leads_moter");
  const { isAdmin } = usePermissions();
  const hasKey = useCanAccessMenu("salgsmuligheter");
  return enabled && (isAdmin || hasKey);
}
